/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { Box, Button, Grid, SxProps } from "@mui/material";
import CustomizedDialogs from "../../Shared/Dialogs/CustomizedDialogs";
import SelectWithLabel from "../../Shared/Dropdown/SelectWithLabel";
import { useStoreDispatch } from "../../../store/hooks";
import { setOpenCustomDailog } from "../../../store/helpers/helperReducers";
import { IRfFeed } from "../../../store/api/deviceConfig/types";
import { useRfFeedData } from "./hooks";
import NumberField from "../../Shared/Inputs/NumberField";

interface IAddEditRfFeedProps {
  selectedRfFeed?: IRfFeed;
  modelOpenMode?: string;
}

const AddEditRfFeed: React.FC<IAddEditRfFeedProps> = ({ modelOpenMode = "Add", selectedRfFeed }) => {
  const dispatch = useStoreDispatch();
  const { RfFeedData, setRfFeedData, isAddNewRfFeed, submitHandler, onblureHandler, errMsg, setErrMsg } = useRfFeedData(selectedRfFeed);
  const selectWithLabelSxProps: SxProps = {
    width: "100%",
    mb: 4,
  };

  const handleChange = (event: any) => {
    event.preventDefault();
    const { name, value } = event.target;
    setRfFeedData({ ...RfFeedData, [name]: value });
    setErrMsg({ ...errMsg, [name]: "" });
  };

  const isEnableSave =
    !!RfFeedData?.index &&
    !!RfFeedData?.type &&
    !!RfFeedData?.dlarfcn &&
    !!RfFeedData?.ularfcn &&
    !!RfFeedData?.dlBandwidth &&
    !!RfFeedData?.ulBandwidth;
  //!!RfFeedData?.dlAttenuation &&
  //!(Object.values(errMsg).filter((item) => !!item && item).length > 0);

  const dialogAction = (
    <Grid container justifyContent="space-around" alignItems="center" sx={{ pt: 2, pb: 2 }}>
      <Button onClick={() => dispatch(setOpenCustomDailog(false))}>Cancel</Button>
      <Button variant="contained" color="primary" disabled={!isEnableSave} onClick={submitHandler}>
        Save
      </Button>
    </Grid>
  );

  const formBoxSxProps: SxProps = { p: 2, "& .MuiTextField-root": { width: "100%", mb: 4 } };
  return (
    <CustomizedDialogs headerTitle={`${modelOpenMode} RF Feed`} dialogActions={dialogAction}>
      <Box component="form" sx={formBoxSxProps} autoComplete="off">
        <Grid container rowSpacing={5} sx={{ p: 4 }}>
          <Grid item md={12} sm={12} xs={12}>
            <NumberField
              label="index"
              name="index"
              required={true}
              inputMode="number"
              disabled={!isAddNewRfFeed}
              value={RfFeedData?.index}
              onChange={handleChange}
              onBlur={onblureHandler}
              error={!!errMsg?.index}
              helperText={errMsg?.index ?? ""}
              min={1}
              max={8}
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <SelectWithLabel
              selectOptions={["RFFeedTypeLTE", "RFFeedTypeNR", "RFFeedTypeUMTS"]}
              id="type"
              keyName="type"
              labelId="type"
              initialValue={RfFeedData?.type}
              inputLabel="Type"
              formControlSx={selectWithLabelSxProps}
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <NumberField
              label="DLARFCN"
              name="dlarfcn"
              required={true}
              inputMode="number"
              value={RfFeedData?.dlarfcn}
              onChange={handleChange}
              onBlur={onblureHandler}
              error={!!errMsg?.dlarfcn}
              helperText={errMsg?.dlarfcn ?? ""}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <NumberField
              label="ULARFCN"
              name="ularfcn"
              required={true}
              inputMode="number"
              value={RfFeedData?.ularfcn}
              onChange={handleChange}
              onBlur={onblureHandler}
              error={!!errMsg?.ularfcn}
              helperText={errMsg?.ularfcn ?? ""}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <NumberField
              label="DLBANDWIDTH"
              name="dlBandwidth"
              required={true}
              inputMode="number"
              value={RfFeedData?.dlBandwidth}
              onChange={handleChange}
              onBlur={onblureHandler}
              error={!!errMsg?.dlBandwidth}
              helperText={errMsg?.dlBandwidth ?? ""}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <NumberField
              label="ULBANDWIDTH"
              name="ulBandwidth"
              required={true}
              inputMode="number"
              value={RfFeedData?.ulBandwidth}
              onChange={handleChange}
              onBlur={onblureHandler}
              error={!!errMsg?.ulBandwidth}
              helperText={errMsg?.ulBandwidth ?? ""}
            />
          </Grid>
          {/* <Grid item md={12} sm={12} xs={12}>
            <TextField 
            label="DLATTENUATION" 
            name="dlAttenuation" 
            value={RfFeedData?.dlAttenuation}
            onChange={handleChange}
            onBlur={onblureHandler}
            error={!!errMsg?.dlAttenuation}
            helperText={errMsg?.dlAttenuation ?? ""}
             />
          </Grid> */}
        </Grid>
      </Box>
    </CustomizedDialogs>
  );
};

export default AddEditRfFeed;
